var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01MAvanzadosCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-227be8df-5519-4ebe-9690-4c52876b855a",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    fill: "#c8c8c6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-60b256a4-1a79-4b63-bcb7-67ca6536b9af"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.77 41.06 26.04 41.06 26.04 61.62 36.77 50.89 36.77 41.06",
    fill: "#c8c8c6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.93 49.64 64.65 49.64 64.65 29.08 53.93 39.8 53.93 49.64",
    fill: "#c8c8c6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.62 26.04 41.06 26.04 41.06 36.77 50.89 36.77 61.62 26.04",
    fill: "#c8c8c6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.77 27.3 27.3 36.77 36.77 36.77 36.77 27.3",
    fill: "#c8c8c6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.93 53.93 53.93 63.4 63.4 53.93 53.93 53.93",
    fill: "#c8c8c6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.64 53.93 39.8 53.93 29.08 64.65 49.64 64.65 49.64 53.93",
    fill: "#c8c8c6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.06,
    y: 41.06,
    width: 8.58,
    height: 8.58,
    fill: "#c8c8c6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01MAvanzadosCw);
export default __webpack_public_path__ + "static/media/01_M-Avanzados-CW.433313b223a5a5c693fa8dd17d8fe937.svg";
export { ForwardRef as ReactComponent };